_ = require 'underscore'
CustomFieldDeleteView = require 'views/custom-field/custom-field-delete-view'
Keyboard = require 'lib/keyboard'
OptionEditorView = require 'views/custom-field/option-editor-view'
PopOver = require 'views/lib/pop-over'
View = require 'view'
Util = require 'lib/util'
t = require('views/internal/teacup-with-helpers')('custom_fields')
trackUe = require 'debug/trackUe'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

template = t.renderable ({ name }) ->
  t.div ->
    t.label { for: 'name' }, -> t.format 'name'
    t.input '.js-field-name',
      name: 'name'
      type: 'text'
      autofocus: true
      spellcheck: true
      value: name
    t.p '.custom-field-error-message.hide.js-duplicate-error', ->
      t.format 'duplicate field'
    t.p '.quiet', ->
      t.format 'changing field name'
    t.div '.js-options-container'
    t.div ->
      t.hr()
      t.a '.quiet.js-delete-field', { href: '#' }, ->
        t.format 'delete field'

module.exports = class CustomFieldEditView extends View
  viewTitleKey: ->
    if @customField.isList() then 'edit field' else 'rename field'

  initialize: ->
    @board = @options.board
    @customField = @options.customField
    @options = @customField.get('options')

  events:
    'click .js-delete-field': 'removeField'
    'keydown .js-field-name': 'handleEnter'
    'input .js-field-name': 'validateName'
    'focusout .js-field-name': 'saveOnBlur'

  render: ->
    @$el.html template({ name: @customField.get('name') })

    if @customField.isList()
      @optionEditor = @subview OptionEditorView,
        @model,
        { @customField },
        "#{@customField.id}-options-editor"
      @appendSubview(@optionEditor, @$('.js-options-container'))

    @

  handleEnter: (e) ->
    if Keyboard.isSubmitEvent(e)
      Util.stop(e)
      @$(e.target).blur()

  validateName: (e) ->
    $el = @$(e.target)
    newName = $el.val().trim()
    if newName.length == 0
      $el.addClass('is-invalid')
      return
    currentName = @customField.get('name')
    isDupe = newName != currentName &&
      @board.hasCustomField(@customField.get('type'), newName)
    $el.toggleClass('is-invalid', isDupe)
    @$('.js-duplicate-error').toggleClass('hide', !isDupe)

  saveOnBlur: (e) ->
    newName = e.target.value.trim()
    oldName = @customField.get('name')
    if newName == oldName
      return

    type = @customField.get('type')
    if newName.length == 0 || @board.hasCustomField(type, newName)
      # restore existing name
      @render()
      return

    @customField.update('name', newName)
    trackUe 'card-detail',
      'edits',
      'custom field definition',
      type,
      '',
      'by clicking the custom field definition',
      CUSTOM_FIELDS_ID

  removeField: (e) ->
    Util.stop(e)
    PopOver.pushView
      elem: @$(e.target)
      view: CustomFieldDeleteView
      options: { @model, @modelCache, @customField }



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-field-edit-view.coffee